// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3hWIf","author":"Table_author__2Qqex","authorImage":"Table_authorImage__2wr0t","unreadRow":"Table_unreadRow__2sIU-"};